module.exports = __webpack_public_path__ + "img/item-list2.05c3bbf3.png";